export default function joinArray(array, max, separator = ", ", last = remaining => ` + ${remaining}`) {
    return !max || max <= 0 ? array.join(separator) : array.slice(0, max).join(separator) + (array.length > max ? last(array.length - max) : "");
}
//# sourceMappingURL=join-array.js.map